import { from } from 'rxjs'
import { Injectable } from '@angular/core'
import { ProjectApiService } from 'src/app/builder-services/api/project.api.service'
import { BuilderService } from './builder-services/builder.service'

@Injectable({
  providedIn: 'root'
})
export class ProtectedImagesService {
  constructor(private projectApi: ProjectApiService, private builder: BuilderService) {}

  setProtectedImages() {
    from(this.projectApi.getProtectedImages()).subscribe((existingImages: string[]) => {
      this.builder.protectedImages = existingImages || []
    })
  }
}
